import React from "react";
import classnames from "classnames";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Label,
  FormGroup,
  InputGroup,
  Input,
  Form,
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import { ToastContainer } from "react-toastify";
import type { SitePermission } from "@/services/userServices/useCurrentPermission";

export type CreateBlogViewProps = {
  alert: React.ReactNode;
  title: string;
  description: string;
  validation: { title: boolean };
  viewAddButton: boolean;
  viewUpdateButton: boolean;
  permission: SitePermission;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onClickAdd: React.MouseEventHandler<HTMLButtonElement>;
  onClickUpdate: React.MouseEventHandler<HTMLButtonElement>;
};

const CreateBlogView = ({
  alert,
  title,
  description,
  validation,
  viewAddButton,
  viewUpdateButton,
  permission,
  onChange,
  onClickAdd,
  onClickUpdate,
}: CreateBlogViewProps) => {
  return (
    <>
      <div className="rna-wrapper">
        <ToastContainer />
      </div>
      {alert}
      <SimpleHeader name="Manage Site Blog" parentName="Global Tools" />
      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col xs="8">
                    <h5 className="h3 mb-0">Create Site Blog</h5>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <FormGroup className="row">
                    <Label className="form-control-label" md="2">
                      Title
                    </Label>
                    <Col md="7">
                      <InputGroup className={classnames("input-group-merge")}>
                        <Input
                          placeholder="Insert Blog Title"
                          name="title"
                          type="text"
                          value={title}
                          onChange={onChange}
                          invalid={!validation.title}
                        />
                      </InputGroup>
                      {!validation.title && (
                        <InputGroup className="invalid-feedback">
                          Required State.
                        </InputGroup>
                      )}
                    </Col>
                  </FormGroup>

                  <FormGroup className="row">
                    <Label className="form-control-label" md="2">
                      Description
                    </Label>
                    <Col md="7">
                      <InputGroup className={classnames("input-group-merge")}>
                        <Input
                          placeholder="Insert Blog Description"
                          name="description"
                          type="textarea"
                          value={description}
                          onChange={onChange}
                          required
                        />
                      </InputGroup>
                      <div className="text-right mt-3">
                        {viewAddButton &&
                          (permission.publish || permission.edit) && (
                            <Button
                              color="primary"
                              onClick={onClickAdd}
                              size="sm"
                            >
                              Add
                            </Button>
                          )}
                        {viewUpdateButton &&
                          (permission.publish || permission.edit) && (
                            <Button
                              color="primary"
                              onClick={onClickUpdate}
                              size="sm"
                            >
                              Update
                            </Button>
                          )}
                      </div>
                    </Col>
                  </FormGroup>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateBlogView;
